import React from "react";
import newsydoozyLogo from '../images/logo1.png'

const NewsItem = (props) => {
    // let { title, description, imageUrl, newsUrl, mode, author, date, source } = props; we can also do something like this and then we can directly use props with their name only like {title} {mode}, etc
    const fallbackImageUrl = newsydoozyLogo;
    const defaultImageStyle = {
        height: "200px",
        objectFit: props.imageUrl ? "cover" : "fill",
    };
    const titleStyle = {
        minHeight: "60px",
    };
    const descriptionStyle = {
        minHeight: "80px",
    };
    const cardContainerStyle = {
        height: "500px", // Adjust the height as per your requirement
        width: "400px",
    };
    const buttonStyle = {
        position: "absolute",
        bottom: "17px", // Adjust the distance from the bottom as per your requirement
        left: "50%",
        transform: "translateX(-50%)",
        width: "365px"
    };
    const paragraphAuthorDateStyle = {
        position: "relative",
        // paddingBottom: "0px" // Adjust the padding as per your desired spacing
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-IN', options).replace(',', ' -');
    };
    
    return (
        <>
            <div className="my-3">
                <div
                    className="card"
                    style={{ width: "18rem", ...cardContainerStyle }}
                >
                    <div>
                        <span className="position-absolute badge bg-danger" style={{ bottom: '58%', right: '0%' }}>
                            {props.source}
                        </span>
                    </div>
                    <img
                        src={props.imageUrl ? props.imageUrl : fallbackImageUrl}
                        className="card-img-top"
                        alt="..."
                        style={defaultImageStyle}
                    />
                    <div className="card-body">
                        <h5 className="card-title" style={titleStyle}>
                            {props.title}...
                        </h5>
                        <p className="card-text" style={descriptionStyle}>
                            {props.description ? props.description : "Click on Read More"}...
                        </p>
                        <p className="card-text" style={paragraphAuthorDateStyle}><small className="text-muted">By {props.author ? props.author : "Unknown"} on {formatDate(props.date)}</small></p>
                        <a
                            href={props.newsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`btn btn-${props.mode} d-flex justify-content-center`}
                            style={buttonStyle}
                        >
                            Read More
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NewsItem;
